import _components, { registerComponents } from './components/formComponents';
import _previewcomponents, { registerPreviewComponents } from './components/preview/previewComponents';
import _filters, { registerFilters } from './filters';
import _formMixin from './mixins/formMixin';
import _previewMixin from './mixins/previewMixin';

export const formMixin = _formMixin;
export const previewMixin = _previewMixin;
export const components = _components;
export const previewComponents = _previewcomponents;
export const filters = _filters;

if (typeof window !== "undefined") {
  window.formComponents = window.fc = components;
  window.previewComponents = window.pc = previewComponents;
  window.formMixin = formMixin;
  window.previewMixin = previewMixin;
  if (window.Vue) {
    if (!window.Vue.config.skipGlobalComponents) {
      registerComponents(window.Vue);
      registerPreviewComponents(window.Vue);
    } else {
      console.log('GelobalComponents: skipped');
    }
    registerFilters(window.Vue);
  }
}


//save client components list
let cmpList = {};
for (const cmp in components) {
  if (object.hasOwnProperty(cmp)) {
    cmpList[cmp] = {};


  }
}

/*
import fs from 'fs';
fs.writeFileSync('../dist/client.list.js', 'export default ' + JSON.stringify(cmpList), { encoding: 'utf-8' })
*/

export default components;